export function parseAnimationOption(option) {
    if (!option)
        return {
            enter: false,
            update: false,
            exit: false,
        };
    if ('enter' in option || 'update' in option || 'exit' in option) {
        return option;
    }
    return {
        enter: option,
        update: option,
        exit: option,
    };
}
export function onAnimateFinished(animation, callback) {
    if (!animation)
        callback();
    else
        animation.finished.then(callback);
}
//# sourceMappingURL=utils.js.map